import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "./api";

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    Promise.all([api.blogList(), api.showcaseList(), api.mediaList().catch(() => [])])
      .then(([blog, sc, media]) => {
        setStats({
          blog: blog.length,
          blogPublished: blog.filter((p) => p.published).length,
          showcase: sc.length,
          showcasePublished: sc.filter((p) => p.published).length,
          media: media.length,
        });
      })
      .catch(() => setStats({}));
  }, []);

  const Card = ({ to, title, value, sub, testId }) => (
    <Link
      to={to}
      data-testid={testId}
      className="block bg-[#0F141A] border border-white/[0.06] rounded-xl p-7 hover:border-[#F4D64E]/30 transition-colors"
    >
      <div className="text-[0.62rem] font-bold tracking-[0.3em] uppercase text-[#F4D64E]">{title}</div>
      <div className="mt-5 font-display text-5xl font-black tracking-[-0.03em] tabular-nums">
        {value ?? "—"}
      </div>
      <div className="mt-2 text-[0.78rem] text-neutral-500">{sub}</div>
    </Link>
  );

  return (
    <div data-testid="admin-dashboard">
      <div className="text-[0.62rem] font-bold tracking-[0.3em] uppercase text-[#F4D64E]">
        Overview
      </div>
      <h1 className="mt-3 font-display text-4xl font-black tracking-[-0.025em] leading-[1.05]">
        Welcome back.
      </h1>
      <p className="mt-3 text-neutral-400 text-sm max-w-prose">
        Manage Blog posts, Showcase case studies, site settings and per-page SEO from here. Changes go live instantly.
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <Card
          to="/admin/blog"
          title="Blog"
          value={stats?.blog}
          sub={`${stats?.blogPublished ?? 0} published`}
          testId="dashboard-blog"
        />
        <Card
          to="/admin/showcase"
          title="Showcase"
          value={stats?.showcase}
          sub={`${stats?.showcasePublished ?? 0} published case studies`}
          testId="dashboard-showcase"
        />
        <Card
          to="/admin/media"
          title="Media"
          value={stats?.media}
          sub="Images and videos"
          testId="dashboard-media"
        />
      </div>
    </div>
  );
}
